import React from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Chip
} from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";

interface QrCodePageProps {
  userData: {
    AccountCode?: string;
    AssociatedAccountCodes?: string[];
  } | null;
}

const QrCodePage: React.FC<QrCodePageProps> = ({ userData }) => {
  if (!userData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography variant="body1" color="text.secondary">
          No user data available
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {/* Account Code Section */}

      <Box display="flex" alignItems="center" mb={2}>
        <QrCodeIcon sx={{ mr: 1, color: "primary.main" }} />
        <Typography variant="h6" fontWeight="600" color="primary.main">
          Account Code
        </Typography>
      </Box>
      <Typography
        variant="h5"
        fontFamily="monospace"
        sx={{
          backgroundColor: "grey.100",
          p: 2,
          borderRadius: 1,
          border: "1px solid",
          borderColor: "grey.300"
        }}
      >
        {userData.AccountCode || "No account code available"}
      </Typography>

      {/* Associated Account Codes Section */}
      <Box display="flex" alignItems="center" mb={2} mt={2}>
        <QrCodeIcon sx={{ mr: 1, color: "secondary.main" }} />
        <Typography variant="h6" fontWeight="600" color="secondary.main">
          Associated Account Codes
        </Typography>
        <Chip
          label={`${userData.AssociatedAccountCodes?.length || 0} codes`}
          size="small"
          sx={{ ml: 2 }}
          color="secondary"
        />
      </Box>

      {userData.AssociatedAccountCodes &&
      userData.AssociatedAccountCodes.length > 0 ? (
        <List sx={{ bgcolor: "background.paper" }}>
          {userData.AssociatedAccountCodes.map((code, index) => (
            <React.Fragment key={code}>
              <ListItem
                sx={{
                  py: 2,
                  border: "1px solid",
                  borderColor: "grey.200",
                  borderRadius: 1,
                  mb: 1,
                  backgroundColor: "grey.50"
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      fontFamily="monospace"
                      fontWeight="500"
                    >
                      {code}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      Associated Account Code #{index + 1}
                    </Typography>
                  }
                />
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100px"
          sx={{
            border: "1px dashed",
            borderColor: "grey.300",
            borderRadius: 1,
            backgroundColor: "grey.50"
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No associated account codes found
          </Typography>
        </Box>
      )}
    </>
  );
};

export default QrCodePage;
